import Orders from 'Portal/components/Orders/Orders'
import Order from 'Portal/components/Orders/Order'

// Routes
export default [
    {
        path: 'orders',
        name: 'orders',
        component: Orders
    },
    {
        path: 'orders/:id',
        name: 'order',
        component: Order
    }
]
